import { selectBuildingInfoByTypeId } from "../../../selectors/selectExistingBuildingInfo";
import { utilBuildings } from "../../../utils/utilBuildings";
import { IdTutorialFocusElement } from "../IdTutorialFocusElement";
import { IdTutorialStep } from "../IdTutorialStep";
import { selectTutorialConfigData } from "../selectors/selectTutorialConfigData";
export var checkTutorialProduceClickStartProduction = function (path) { return function (action, state$, dependencies) {
    var state = state$.value;
    var _a = selectTutorialConfigData(state), tutorialStepConfig = _a.tutorialStepConfig, nextTutorialStepConfig = _a.nextTutorialStepConfig;
    if (tutorialStepConfig.nextStep !== IdTutorialStep.produceChickenFeed_clickStartProduction) {
        return undefined;
    }
    var hasFocusId = nextTutorialStepConfig.focusId != undefined;
    var hasBuildingId = nextTutorialStepConfig.buildingId !== undefined;
    if (!hasFocusId && !hasBuildingId) {
        return undefined;
    }
    if (nextTutorialStepConfig.focusId !== IdTutorialFocusElement.button_start_production) {
        return undefined;
    }
    var focusBuilding = selectBuildingInfoByTypeId(state, nextTutorialStepConfig.buildingId);
    var hasFinishedProduction = utilBuildings.hasFinishedProduction(focusBuilding, state.productionInfo.removedProductions);
    return !hasFinishedProduction ? path : undefined;
}; };



//////////////////
// WEBPACK FOOTER
// ./src/features/tutorial/checks/checkTutorialProduceClickStartProduction.ts
// module id = 2490
// module chunks = 3